export function downloadFile(fileUrl: string, fileName: string, target = '_blank') {
  let link = document.createElement('a');

  link.href = fileUrl;
  link.download = fileName;
  link.target = target;

  link.click();
}
